import React, { useState, useRef, useEffect } from "react";
import Header from "../Navbar/page";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Api from "../Api/Api";
import { useFormik } from "formik";
import * as yup from "yup";
import { useTimer } from "react-timer-hook";
// import { socket } from "../Socket/page";
import AudioSound from "../sound/audio.mp3";
import { use } from "react";
import useSound from "use-sound";

function Page() {
  const [pagetNumberDisplay, setPagetNumberDisplay] = useState(1);
  const [answerData, setAnswerData] = useState();
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [answerCorrect, setAswerCorrect] = useState(false);
  const [answertotalScore, setAnswertotalScore] = useState("");
  const [setinputEditable, setSetinputEditable] = useState(false);
  const [timer, setTimer] = useState(1);
  const [Liveuser, setLiveuser] = useState(0);
  const [MicroDataTime, setMicroDataTime] = useState(0);
  const [startTime, setStartTime] = useState(null); // New state for start time
  const [endTime, setEndTime] = useState(null);
  const [durationDataTime, setDurationDataTime] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0,
    nanoseconds: 0,
  });

  const location = useLocation();
  const closeButtonRef = useRef(null);
  const navigate = useNavigate();
  const [play, { stop }] = useSound(AudioSound);

  const handleStart = () => {
    const now = new Date();
    setStartTime(now);
    console.log("startttt----->", now);
    setEndTime(null); // Reset the end time for a new session
    setDurationDataTime(null); // Reset the duration
  };

  const formatTime = (time) => {
    const hours = Math.floor((time / 3600000) % 24);
    const minutes = Math.floor((time / 60000) % 60);
    const seconds = Math.floor((time / 1000) % 60);
    const milliseconds = Math.floor(time % 1000);
    return `${hours}h ${minutes}m ${seconds}s ${milliseconds}ms`;
  };

  const quizSteps = [
    {
      stepNumber: 1,
      question: "Who invented the telephone?",
      options: [
        { id: 1, idStyle: "center", text: "Nikola Tesla" },
        { id: 2, idStyle: "right", text: "Thomas Edison" },
        { id: 3, idStyle: "right", text: "Alexander Graham Bell" },
        { id: 4, idStyle: "right", text: "Isaac Newton" },
        { id: 5, idStyle: "right", text: "Nikola Tesla" },
      ],
      audioSrc: "assets/audio/audio.mp3",
      correctAnswer: "Hong Kong",
    },
    {
      stepNumber: 2,
      question: "Which is the largest country by area?",
      options: [
        { id: "center", text: "Canada" },
        { id: "right", text: "United States" },
        { id: "right", text: "Russia" },
        { id: "right", text: "China" },
        { id: "right", text: "Brazil" },
      ],
      audioSrc: "assets/audio/audio.mp3",
      correctAnswer: "Horse",
    },
    {
      stepNumber: 3,
      question: "Who wrote the famous play 'Romeo and Juliet'?",
      options: [
        { id: "center", text: "Charles Dickens" },
        { id: "right", text: "William Shakespeare" },
        { id: "right", text: "Both (a) and (b)" },
        { id: "right", text: "None of the above" },
        { id: "right", text: "Jane Austen" },
      ],
      audioSrc: "assets/audio/wrong-answer.mp3",
      correctAnswer: "Both (a) and (b)",
    },
    {
      stepNumber: 4,
      question: "What is the boiling point of water in Celsius?",
      options: [
        { id: "center", text: "50°C" },
        { id: "right", text: "60°C" },
        { id: "right", text: "100°C" },
        { id: "right", text: "120°C" },
        { id: "right", text: "150°C" },
      ],
      audioSrc: "assets/audio/audio.mp3",
      correctAnswer: "Hong Kong",
    },
    {
      stepNumber: 5,
      question: "What is the name of the longest river in the world?",
      options: [
        { id: "center", text: "Amazon River" },
        { id: "right", text: "Nile River" },
        { id: "right", text: "Yangtze River" },
        { id: "right", text: " Mississippi River" },
        { id: "right", text: "Brahmaputra" },
      ],
      audioSrc: "assets/audio/audio.mp3",
      correctAnswer: "Horse",
    },
  ];

  const quizStepThree = [
    {
      stepNumber: 1,
      question: "Which former British colony was given back to China in 1997?",
      options: [
        { id: 1, idStyle: "center", text: "Russia" },
        { id: 2, idStyle: "right", text: "America" },
        { id: 3, idStyle: "right", text: "Australia" },
        { id: 4, idStyle: "right", text: "Hong Kong" },
        { id: 5, idStyle: "right", text: "United Kingdom" },
      ],
      audioSrc: "/assets/audio/audio.mp3",
      correctAnswer: "Hong Kong",
    },
    {
      stepNumber: 2,
      question: "The logo For Luxury Car Maker Porsche Features Which Animal?",
      options: [
        { id: "center", text: "Horse" },
        { id: "right", text: "Dog" },
        { id: "right", text: "Cat" },
        { id: "right", text: "Tiger" },
        { id: "right", text: "Lion" },
      ],
      audioSrc: "/assets/audio/audio.mp3",
      correctAnswer: "Horse",
    },
    {
      stepNumber: 3,
      question: "The islands With Coral Covered Surfaces in Bay of Bengal are?",
      options: [
        { id: "center", text: "Andman Island" },
        { id: "right", text: "Nicobar Island" },
        { id: "right", text: "Both (a) and (b)" },
        { id: "right", text: "None of the above" },
        { id: "right", text: "Havelock Island" },
      ],
      audioSrc: "/assets/audio/wrong-answer.mp3",
      correctAnswer: "Both (a) and (b)",
    },
    {
      stepNumber: 4,
      question: "What is the national currency of Japan?",
      options: [
        { id: "center", text: "Yen" },
        { id: "right", text: "Won" },
        { id: "right", text: "Dollar" },
        { id: "right", text: "Peso" },
        { id: "right", text: "rufiyaa" },
      ],
      audioSrc: "/assets/audio/audio.mp3",
      correctAnswer: "Hong Kong",
    },
    {
      stepNumber: 5,
      question: "How many days are there in a leap year?",
      options: [
        { id: "center", text: "364" },
        { id: "right", text: "365" },
        { id: "right", text: "366" },
        { id: "right", text: "367" },
        { id: "right", text: "300" },
      ],
      audioSrc: "/assets/audio/audio.mp3",
      correctAnswer: "Horse",
    },
  ];

  const ResultFunction = () => {
    navigate("/resultpage");
  };

  const confirmPagefun = (valuesNumber) => {
    setAnswerData();
    const valueIncress = valuesNumber + 1;
    setPagetNumberDisplay(valueIncress);
    setSetinputEditable(false);
    
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (valuesNumber == 5) {
      console.log("Total time taken in microseconds:--------", timer * 1000);
      navigate("/resultpage", {
        state: {
          answer: answertotalScore,
          level: "medium",
          gameid: location.state.GameId,
          timertemp: timer * 1000,
        },
      });
    }


  };

  const initialValues = {
    resultId: "",
    result: "",
  };

  const validationFun = yup.object({
    // resultId:yup.number().required("Required"),
    result: yup.string().required("Select your answer"),
  });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationFun,
    onSubmit: async (values) => {
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
      play();
      setSetinputEditable(true);
      let newScore = answertotalScore || 0; // Ensure prevScore is not undefined
      let isCorrect = false;

      if (values.resultId === 1) {
        if (values.result === "Alexander Graham Bell") {
          newScore += 20; // Increment score
          isCorrect = true;
        }
      } else if (values.resultId === 2) {
        if (values.result === "Russia") {
          newScore += 20; // Increment score
          isCorrect = true;
        }
      } else if (values.resultId === 3) {
        if (values.result === "William Shakespeare") {
          newScore += 20;
          isCorrect = true;
        }
      } else if (values.resultId === 4) {
        if (values.result === "100°C") {
          newScore += 20;
          isCorrect = true;
        }
      } else if (values.resultId === 5) {
        if (values.result === "Nile River") {
          newScore += 20;
          isCorrect = true;
        }
      }
      setAswerCorrect(isCorrect);
      await Answermatchfun(values.resultId);
      setAnswertotalScore(newScore); 
      formik.resetForm(); 
    },
  });

  const Answermatchfun = async (values) => {
    setAnswerData(values);
  };

  useEffect(() => {
    // setIsActive(true)
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer + 1);
      }, 1000);
      return () => clearInterval(interval); // Clear interval on component unmount
    }
  }, [timer]);

  useEffect(() => {
    handleStart();
  }, []);

  return (
    <>
      <Header />

      <div className="wrapper overflow-hidden ">
        {/* <!-- Top content --> */}

        <div className="container position-relative">
          <div className="count_box d-flex float-end pt-5 pe-5 position">
            <div className="count_progress clip-1">
              <span className="progress-left">
                <span className="progress_bar"></span>
              </span>
              <span className="progress-right">
                <span className="progress_bar"></span>
              </span>
            </div>

            <span
              style={{
                color: "black",
                backgroundColor: "white",
                padding: "10px",
                border: "2px solid black",
                borderRadius: "10px",
              }}
            >
              {formatTime(timer * 100)}
            </span>
          </div>

          <form
            className="multisteps_form bg-white position-relative overflow-hidden"
            id="wizard"
            onSubmit={formik.handleSubmit}
          >
            {/* <!------------------------- Step-1 -----------------------------> */}
            <div>
              {location.state.gameLevel === 2 ? (
                <>
                  {quizSteps.map((value, index) => (
                    <div key={index}>
                      <div
                        className="multisteps_form_panel step"
                        style={{
                          display:
                            pagetNumberDisplay === value.stepNumber
                              ? "block"
                              : "none",
                        }}
                      >
                        <div className="upper-work">
                          <div className="question_number text-center text-uppercase text-white">
                            <span className="rounded-pill">
                              Question {value.stepNumber} of 5
                            </span>
                          </div>

                          <div className="level">
                            <span>
                              <img src="/assets/images/icon/step.png" />
                              Level : 2
                            </span>

                            {/* <span>
                    <img src="/assets/images/icon/family.png" />
                    Lives : 1
                  </span> */}
                          </div>
                        </div>

                        <h2 className="q-heading">
                          {/* Which former British colony was given back to China in 1997? */}
                          {value.question}
                        </h2>

                        <div className="row pt-5 form_items">
                          <div className="selectYear">
                            <ul key={index}>
                              <div className="row">
                                {value.options.map((item, index) => (
                                  <div className="col-6 mb-6" key={index}>
                                    <li>
                                      {/* <input type="radio" name="result" value={item.text} onChange={formik.handleChange} id={item.idstyle}  /> */}
                                      <input
                                        type="radio"
                                        name="result"
                                        value={item.text}
                                        // readOnly={true}
                                        disabled={setinputEditable}
                                        onChange={(e) => {
                                          formik.setFieldValue(
                                            "result",
                                            e.target.value
                                          );
                                          formik.setFieldValue(
                                            "resultId",
                                            value.stepNumber
                                          );
                                        }}
                                      />
                                      <div>
                                        <h4>{item.text}</h4>
                                        <i className="fas fa-check-circle"></i>
                                      </div>
                                    </li>
                                  </div>
                                ))}
                                {formik.touched.result &&
                                formik.errors.result ? (
                                  <div
                                    className="text-danger"
                                    style={{ float: "right", padding: "9px",fontWeight: '600' }}
                                  >
                                    {formik.errors.result}
                                  </div>
                                ) : null}

                                {formik.touched.resultId &&
                                formik.errors.resultId ? (
                                  <div
                                    className="text-danger"
                                    style={{ float: "right", padding: "9px",fontWeight: '600' }}
                                  >
                                    {formik.errors.resultId}
                                  </div>
                                ) : null}
                              </div>
                            </ul>
                          </div>

                          <div className="confirm-btn Hidebtn-1" id="ajaxCall">
                            <div id="player">
                              <audio id="audio" controls>
                                <source
                                
                                  src={AudioSound}
                                  // type="audio/aac"
                                  type="audio/mpeg"
                                  codecs="aac"
                                ></source>
                              </audio>
                            
                              {answerData === value.stepNumber ? (
                                ""
                              ) : (
                                <div className="cover">
                                  <div className="controls">
                                    <button
                                      id="play-pause"
                                      title="Play"
                                      type="submit"
                                    >
                                      <div className="next_btn rounded-pill text-uppercase text-white">
                                        <span>
                                          <a>Confirm </a>
                                        </span>
                                        {/* </div> */}
                                      </div>
                                    </button>
                                  </div>
                                </div>
                              )}
                              
                            </div>
                          

                            <div className="">
                              {answerData === value.stepNumber ? (
                                <>
                                  {answerCorrect ? (
                                    <div className="popup-score">
                                      <h3 className="popup-head">
                                        Hurray! Your Answer is correct.
                                      </h3>
                                      <div className="u_result">
                                        <div className="u_score">
                                          Your Score:{" "}
                                        </div>
                                        {/* <!-- <div className="u_prcnt">20%</div> --> */}
                                        <span>20 Points</span>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="popup-score">
                                      <h3 className="popup-head text-danger">
                                        Oops! Your Answer is Incorrect.
                                      </h3>
                                      <div className="u_result">
                                        <div className="u_score">
                                          Your Score:{" "}
                                        </div>
                                        <span>0 Points</span>
                                      </div>
                                    </div>
                                  )}

                                  <div className="form_btn" id='scrollerData'>
                                    <a href="#">
                                      <button
                                        type="button"
                                        className="next_btn rounded-pill text-uppercase text-white Hide"
                                        id="nextBtn"
                                        //   onclick="nextPrev(1)"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          confirmPagefun(value.stepNumber);
                                        }}
                                      >
                                        Next
                                      </button>
                                    </a>
                                  </div>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <>
                  {quizStepThree.map((value, index) => (
                    <div key={index}>
                      <div
                        className="multisteps_form_panel step"
                        style={{
                          display:
                            pagetNumberDisplay === value.stepNumber
                              ? "block"
                              : "none",
                        }}
                      >
                        <div className="upper-work">
                          <div className="question_number text-center text-uppercase text-white">
                            <span className="rounded-pill">
                              Question {value.stepNumber} of 5
                            </span>
                          </div>

                          <div className="level">
                            <span>
                              <img src="/assets/images/icon/step.png" />
                              Level : 3
                            </span>

                            {/* <span>
                    <img src="/assets/images/icon/family.png" />
                    Lives : 1
                  </span> */}
                          </div>
                        </div>

                        <h2 className="q-heading">
                          {/* Which former British colony was given back to China in 1997? */}
                          {value.question}
                        </h2>

                        <div className="row pt-5 form_items">
                          <div className="selectYear">
                            <ul key={index}>
                              <div className="row">
                                {value.options.map((item, index) => (
                                  <div className="col-6 mb-6" key={index}>
                                    <li>
                                      {/* <input type="radio" name="result" value={item.text} onChange={formik.handleChange} id={item.idstyle}  /> */}
                                      <input
                                        type="radio"
                                        name="result"
                                        value={item.text}
                                        // readOnly={true}
                                        disabled={setinputEditable}
                                        onChange={(e) => {
                                          formik.setFieldValue(
                                            "result",
                                            e.target.value
                                          );
                                          formik.setFieldValue(
                                            "resultId",
                                            value.stepNumber
                                          );
                                        }}
                                      />
                                      <div>
                                        <h4>{item.text}</h4>
                                        <i className="fas fa-check-circle"></i>
                                      </div>
                                    </li>
                                  </div>
                                ))}
                                {formik.touched.result &&
                                formik.errors.result ? (
                                  <div
                                    className="text-danger"
                                    style={{ float: "right", padding: "9px" }}
                                  >
                                    {formik.errors.result}
                                  </div>
                                ) : null}

                                {formik.touched.resultId &&
                                formik.errors.resultId ? (
                                  <div
                                    className="text-danger"
                                    style={{ float: "right", padding: "9px" }}
                                  >
                                    {formik.errors.resultId}
                                  </div>
                                ) : null}
                              </div>
                            </ul>
                          </div>

                          <div className="confirm-btn Hidebtn-1" id="ajaxCall">
                            <div id="player">
                              <audio id="audio" controls>
                                <source
                                  // src={value.audioSrc}
                                  src={AudioSound}
                                  // type="audio/aac"
                                  type="audio/mpeg"
                                  codecs="aac"
                                ></source>
                              </audio>
                              {/* <!-- <input type="checkbox" id="to-lyrics">  --> */}
                              {answerData === value.stepNumber ? (
                                ""
                              ) : (
                                <div className="cover">
                                  <div className="controls">
                                    <button
                                      id="play-pause"
                                      title="Play"
                                      type="submit"
                                    >
                                      <div className="next_btn rounded-pill text-uppercase text-white">
                                        <span>
                                          <a>Confirm </a>
                                        </span>
                                        {/* </div> */}
                                      </div>
                                    </button>
                                  </div>
                                </div>
                              )}
                              {/* <!-- #cover --> */}
                            </div>
                            <div className="">
                              {answerData === value.stepNumber ? (
                                <>
                                  {answerCorrect ? (
                                    <div className="popup-score">
                                      <h3 className="popup-head">
                                        Hurray! Your Answer is correct.
                                      </h3>
                                      <div className="u_result">
                                        <div className="u_score">
                                          Your Score:{" "}
                                        </div>
                                        {/* <!-- <div className="u_prcnt">20%</div> --> */}
                                        <span>20 Points</span>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="popup-score">
                                      <h3 className="popup-head text-danger">
                                        Oops! Your Answer is Incorrect.
                                      </h3>
                                      <div className="u_result">
                                        <div className="u_score">
                                          Your Score:{" "}
                                        </div>
                                        <span>0 Points</span>
                                      </div>
                                    </div>
                                  )}

                                  <div className="form_btn">
                                    <a href="#">
                                      <button
                                        type="button"
                                        className="next_btn rounded-pill text-uppercase text-white Hide"
                                        id="nextBtn"
                                        //   onclick="nextPrev(1)"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          confirmPagefun(value.stepNumber);
                                        }}
                                      >
                                        Next
                                      </button>
                                    </a>
                                  </div>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Page;
